import type {EnumValues} from 'typings/portaro.fe.types';

export const COLUMN_TYPES = {
    CONTROL: 'CONTROL',
    TOP_COLUMN: 'TOP_COLUMN',
    DATA_COLUMN: 'DATA_COLUMN'
} as const;

export type ColumnType = EnumValues<typeof COLUMN_TYPES>;